// Единственное место, где подключается чат техподдержки. Код виджета — Carrot
// Quest, проект тот же, что на fintablo.ru: обращение из платформы интеграций
// попадает в общий инбокс поддержки, а история пользователя не разрывается
// между сайтом и приложением. Ключ виджета публичный (он и так уходит в
// браузер в составе страницы), поэтому живёт в коде, а не в секретах окружения.
export const SUPPORT_CHAT_API_KEY = '34374-8aefb2be8796686aac2cb2305a'

const SUPPORT_CHAT_SCRIPT_URL = 'https://cdn.carrotquest.app/api.min.js'

// Состав методов задан снипетом Carrot Quest: до загрузки скрипта вызовы
// копятся в очереди и проигрываются, когда виджет поднимется.
const QUEUED_METHODS = [
  'connect', 'track', 'identify', 'auth',
  'onReady', 'addCallback', 'removeCallback', 'trackMessageInteraction'
]

function queuedMethod (browserWindow, name) {
  return function () {
    browserWindow.carrotquestasync.push(name, arguments)
  }
}

// Возвращает true, если виджет подключён этим вызовом.
export function initSupportChat (browserWindow = window) {
  // Внутри third-party iframe CRM (слайдер Bitrix24) чат не поднимаем: это узкая
  // колонка чужого интерфейса, а cookie виджета там всё равно режет браузер.
  // В обычном окне платформы чат доступен и до, и после входа.
  if (browserWindow.self !== browserWindow.top) return false
  // Повторный вызов не должен заводить второй экземпляр виджета.
  if (browserWindow.carrotquest) return false

  const carrotquest = {}
  browserWindow.carrotquest = carrotquest
  browserWindow.carrotquestasync = []
  carrotquest.settings = {}
  for (const method of QUEUED_METHODS) {
    carrotquest[method] = queuedMethod(browserWindow, method)
  }

  const script = browserWindow.document.createElement('script')
  script.type = 'text/javascript'
  script.async = true
  script.src = SUPPORT_CHAT_SCRIPT_URL
  browserWindow.document.getElementsByTagName('head')[0].appendChild(script)

  carrotquest.connect(SUPPORT_CHAT_API_KEY)
  return true
}

// Имя источника вместе с аккаунтом: по «Bitrix24: acme.bitrix24.ru» оператор
// находит портал, о котором идёт речь. Где отдельного имени аккаунта нет,
// display_name повторяет название коннектора — тогда не дублируем его.
function describeConnections (connections) {
  return connections
    .map(connection => {
      const title = connection.name || connection.slug
      const account = connection.display_name
      return account && account !== title ? `${title}: ${account}` : title
    })
    .join(', ')
}

// Поддержка должна видеть, кто пишет: без email обращение из приложения нельзя
// связать с аккаунтом. Список источников берём из подключений, а не из полей
// пользователя: `users.amocrm_domain` знает только про amoCRM и ничего не
// говорит про Bitrix24 и остальные коннекторы.
// Личность не подтверждена подписью (carrotquest.auth), свойства служат
// оператору для навигации, а не как право доступа.
export function identifySupportChatUser (user, connections, browserWindow = window) {
  if (!user?.email) return false
  if (typeof browserWindow.carrotquest?.identify !== 'function') return false

  const properties = {
    $email: user.email,
    'Платформа интеграций: id пользователя': user.id
  }
  // Подключения приходят отдельным запросом и могут не дойти. Пустое свойство
  // хуже отсутствующего: оператор прочитал бы «источников нет» там, где их
  // просто не успели загрузить.
  if (connections) {
    properties['Платформа интеграций: подключённые источники'] =
      describeConnections(connections) || 'нет'
  }

  browserWindow.carrotquest.identify(properties)
  return true
}
